const serverPropertiesSchema = [
{
  key: 'enable-jmx-monitoring',
  label: 'Enable JMX Monitoring',
  type: 'boolean',
  description: 'Expose JVM metrics for external monitoring.'
},
{
  key: 'rcon.port',
  label: 'RCON Port',
  type: 'number',
  description: 'Port for remote console (RCON).'
},
{
  key: 'level-seed',
  label: 'Level Seed',
  type: 'string',
  description: 'World seed; leave blank for random.'
},
{
  key: 'gamemode',
  label: 'Game Mode',
  type: 'select',
  options: [
  { value: 'survival', label: 'Survival' },
  { value: 'creative', label: 'Creative' },
  { value: 'adventure', label: 'Adventure' },
  { value: 'spectator', label: 'Spectator' }],

  description: 'Default game mode for new players.'
},
{
  key: 'enable-command-block',
  label: 'Enable Command Blocks',
  type: 'boolean',
  description: 'Allow command blocks to run.'
},
{
  key: 'enable-query',
  label: 'Enable Query',
  type: 'boolean',
  description: 'Enable the GameSpy query protocol.'
},
{
  key: 'generator-settings',
  label: 'Generator Settings',
  type: 'string',
  description: 'Custom generator options (JSON-like).'
},
{
  key: 'enforce-secure-profile',
  label: 'Enforce Secure Profile',
  type: 'boolean',
  description: 'Require secure profiles for chat signing.'
},
{
  key: 'level-name',
  label: 'Level Name',
  type: 'string',
  description: 'World folder name.'
},
{
  key: 'motd',
  label: 'Message of the Day',
  type: 'string',
  description: 'Server list description.'
},
{
  key: 'query.port',
  label: 'Query Port',
  type: 'number',
  description: 'Port for the query protocol.'
},
{
  key: 'pvp',
  label: 'Player vs Player',
  type: 'boolean',
  description: 'Allow PvP combat.'
},
{
  key: 'generate-structures',
  label: 'Generate Structures',
  type: 'boolean',
  description: 'Generate villages and other structures.'
},
{
  key: 'max-chained-neighbor-updates',
  label: 'Max Chained Neighbor Updates',
  type: 'number',
  description: 'Limits block update chains.'
},
{
  key: 'difficulty',
  label: 'Difficulty',
  type: 'select',
  options: [
  { value: 'peaceful', label: 'Peaceful' },
  { value: 'easy', label: 'Easy' },
  { value: 'normal', label: 'Normal' },
  { value: 'hard', label: 'Hard' }],

  description: 'World difficulty.'
},
{
  key: 'network-compression-threshold',
  label: 'Network Compression Threshold',
  type: 'number',
  description: 'Packet size threshold for compression (-1 disables).'
},
{
  key: 'max-tick-time',
  label: 'Max Tick Time',
  type: 'number',
  description: 'Time in ms before watchdog stops server.'
},
{
  key: 'require-resource-pack',
  label: 'Require Resource Pack',
  type: 'boolean',
  description: 'Force players to accept the resource pack.'
},
{
  key: 'use-native-transport',
  label: 'Use Native Transport',
  type: 'boolean',
  description: 'Use optimized network transport when available.'
},
{
  key: 'max-players',
  label: 'Max Players',
  type: 'number',
  description: 'Player slot limit.'
},
{
  key: 'online-mode',
  label: 'Online Mode',
  type: 'boolean',
  description: 'Authenticate players with Mojang/Microsoft.'
},
{
  key: 'enable-status',
  label: 'Enable Status',
  type: 'boolean',
  description: 'Allow status ping from server list.'
},
{
  key: 'allow-flight',
  label: 'Allow Flight',
  type: 'boolean',
  description: 'Allow players to fly.'
},
{
  key: 'initial-disabled-packs',
  label: 'Initial Disabled Packs',
  type: 'string',
  description: 'Comma-separated data packs to disable.'
},
{
  key: 'broadcast-rcon-to-ops',
  label: 'Broadcast RCON to Ops',
  type: 'boolean',
  description: 'Send RCON output to ops.'
},
{
  key: 'view-distance',
  label: 'View Distance',
  type: 'number',
  description: 'Chunks sent to clients.'
},
{
  key: 'server-ip',
  label: 'Server IP',
  type: 'string',
  description: 'Bind address; blank for all interfaces.'
},
{
  key: 'resource-pack-prompt',
  label: 'Resource Pack Prompt',
  type: 'string',
  description: 'Optional prompt text for resource pack.'
},
{
  key: 'allow-nether',
  label: 'Allow Nether',
  type: 'boolean',
  description: 'Allow the Nether dimension.'
},
{
  key: 'server-port',
  label: 'Server Port',
  type: 'number',
  description: 'Main server port.'
},
{
  key: 'enable-rcon',
  label: 'Enable RCON',
  type: 'boolean',
  description: 'Allow remote console (RCON).'
},
{
  key: 'sync-chunk-writes',
  label: 'Sync Chunk Writes',
  type: 'boolean',
  description: 'Write chunk data synchronously.'
},
{
  key: 'op-permission-level',
  label: 'OP Permission Level',
  type: 'number',
  description: 'Permission level for ops (1-4).'
},
{
  key: 'prevent-proxy-connections',
  label: 'Prevent Proxy Connections',
  type: 'boolean',
  description: 'Reject players using proxies.'
},
{
  key: 'hide-online-players',
  label: 'Hide Online Players',
  type: 'boolean',
  description: 'Hide player list from status.'
},
{
  key: 'resource-pack',
  label: 'Resource Pack URL',
  type: 'string',
  description: 'URL to server resource pack.'
},
{
  key: 'entity-broadcast-range-percentage',
  label: 'Entity Broadcast Range %',
  type: 'number',
  description: 'Broadcast range multiplier.'
},
{
  key: 'simulation-distance',
  label: 'Simulation Distance',
  type: 'number',
  description: 'Chunks ticked around players.'
},
{
  key: 'rcon.password',
  label: 'RCON Password',
  type: 'string',
  description: 'Password for RCON.'
},
{
  key: 'player-idle-timeout',
  label: 'Player Idle Timeout',
  type: 'number',
  description: 'Minutes before idle kick (0 disables).'
},
{
  key: 'force-gamemode',
  label: 'Force Gamemode',
  type: 'boolean',
  description: 'Force players into the default gamemode.'
},
{
  key: 'rate-limit',
  label: 'Rate Limit',
  type: 'number',
  description: 'Packets per second per IP (0 disables).'
},
{
  key: 'hardcore',
  label: 'Hardcore Mode',
  type: 'boolean',
  description: 'Hardcore difficulty with ban on death.'
},
{
  key: 'white-list',
  label: 'Whitelist',
  type: 'boolean',
  description: 'Only allow whitelisted players.'
},
{
  key: 'broadcast-console-to-ops',
  label: 'Broadcast Console to Ops',
  type: 'boolean',
  description: 'Send console output to ops.'
},
{
  key: 'spawn-npcs',
  label: 'Spawn NPCs',
  type: 'boolean',
  description: 'Spawn villagers.'
},
{
  key: 'spawn-animals',
  label: 'Spawn Animals',
  type: 'boolean',
  description: 'Spawn passive mobs.'
},
{
  key: 'function-permission-level',
  label: 'Function Permission Level',
  type: 'number',
  description: 'Permission level for functions.'
},
{
  key: 'initial-enabled-packs',
  label: 'Initial Enabled Packs',
  type: 'string',
  description: 'Comma-separated data packs to enable.'
},
{
  key: 'level-type',
  label: 'Level Type',
  type: 'string',
  description: 'World type (e.g., minecraft:normal).'
},
{
  key: 'text-filtering-config',
  label: 'Text Filtering Config',
  type: 'string',
  description: 'Text filtering configuration.'
},
{
  key: 'spawn-monsters',
  label: 'Spawn Monsters',
  type: 'boolean',
  description: 'Spawn hostile mobs.'
},
{
  key: 'enforce-whitelist',
  label: 'Enforce Whitelist',
  type: 'boolean',
  description: 'Only allow whitelisted players.'
},
{
  key: 'spawn-protection',
  label: 'Spawn Protection',
  type: 'number',
  description: 'Spawn protection radius in blocks.'
},
{
  key: 'resource-pack-sha1',
  label: 'Resource Pack SHA1',
  type: 'string',
  description: 'SHA1 hash for resource pack.'
},
{
  key: 'max-world-size',
  label: 'Max World Size',
  type: 'number',
  description: 'World border size limit in blocks.'
}];


const parseProperties = (content, schemaKeys) => {
  const lines = String(content || '').split(/\r?\n/);
  const values = {};
  const extraKeys = [];
  const extraSet = new Set();
  const prefixLines = [];
  let seenEntry = false;

  lines.forEach((line) => {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith('#') || !line.includes('=')) {
      if (!seenEntry) prefixLines.push(line);
      return;
    }
    seenEntry = true;
    const idx = line.indexOf('=');
    const key = line.slice(0, idx).trim();
    const value = line.slice(idx + 1);
    values[key] = value;
    if (!schemaKeys.includes(key) && !extraSet.has(key)) {
      extraSet.add(key);
      extraKeys.push(key);
    }
  });

  return { values, extraKeys, prefixLines };
};

const serializeProperties = ({ values, extraKeys, prefixLines, schemaKeys }) => {
  const lines = [];
  if (prefixLines && prefixLines.length > 0) {
    lines.push(...prefixLines);
  } else {
    lines.push('#Minecraft server properties');
  }

  schemaKeys.forEach((key) => {
    const raw = Object.prototype.hasOwnProperty.call(values, key) ? values[key] : '';
    lines.push(`${key}=${raw ?? ''}`);
  });

  extraKeys.forEach((key) => {
    if (schemaKeys.includes(key)) return;
    const raw = Object.prototype.hasOwnProperty.call(values, key) ? values[key] : '';
    lines.push(`${key}=${raw ?? ''}`);
  });

  return lines.join('\n');
};

const serverPropertiesEditor = {
  id: 'minecraft-server-properties',
  title: 'Minecraft Server Properties',
  matches: (editor) => {
    const path = editor?.path || '';
    return path.toLowerCase().endsWith('server.properties');
  },
  schema: serverPropertiesSchema,
  parse: (content) =>
  parseProperties(
    content,
    serverPropertiesSchema.map((field) => field.key)
  ),
  serialize: (payload) =>
  serializeProperties({
    ...payload,
    schemaKeys: serverPropertiesSchema.map((field) => field.key)
  })
};

const configEditors = [serverPropertiesEditor];

const getConfigEditor = (editor) =>
configEditors.find((entry) => entry.matches(editor)) || null;

export { configEditors, getConfigEditor };